import { DarkMode, LightMode } from "../../data/common/svgImages";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ThemeSwitcher = () => {
  const [mount, setMount] = useState(false);
  const [offerIdFromStorage, setOfferIdFromStorage] = useState("");

  const { systemTheme, theme, setTheme } = useTheme();
  const currentTheme = theme === "system" ? systemTheme : theme;
  const navigate = useNavigate();

  useEffect(() => {
    setOfferIdFromStorage(localStorage.getItem("offerId") || "");
  }, []);

  useEffect(() => {
    setMount(true);
  }, []);

  const handleChangeTheme = (newTheme) => {
    const insureframe = document.getElementById("insureframe");
    setTheme(newTheme);

    if (insureframe) {
      insureframe.contentWindow.postMessage(
        {
          eventName: "SET_THEME",
          details: {
            theme: newTheme === "dark" ? "dark" : "light",
          },
        },
        "*"
      );
    }
  };

  return mount ? (
    <div className="toggle-button fixed right-5 z-50 max-lg:bottom-2.5 lg:top-1/2">
      {!!offerIdFromStorage?.length && (
        <button
          onClick={() => navigate(`/rca/${offerIdFromStorage}`)}
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-md border border-paragraph/25 text-paragraph focus:outline-none focus:ring-0 focus:ring-gray-200 dark:border-borderColor-dark dark:text-white"
        >
          <svg
            className="h-6 w-6 text-gray-800 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 4h1.5L9 16m0 0h8m-8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-8.5-3h9.25L19 7H7.312"
            />
          </svg>
        </button>
      )}
      <button
        onClick={() =>
          handleChangeTheme(currentTheme === "dark" ? "light" : "dark")
        }
        type="button"
        className="mt-5 flex h-10 w-10 items-center justify-center rounded-md border border-paragraph/25 bg-white text-paragraph focus:outline-none focus:ring-0 focus:ring-gray-200 dark:border-borderColor-dark dark:bg-black dark:text-white"
      >
        <LightMode />
        <DarkMode />
      </button>
    </div>
  ) : null;
};

export default ThemeSwitcher;
